import { useContext } from "react";
import { Box, Stack, Typography, Grid } from "@mui/material";
import { AuthContext } from "../../../Context/AuthContext";

export default function HomeworkHeader({ tableData }) {
  const { t } = useContext(AuthContext);

  const stats = [
    {
      label: t("thead_complete"),
      value: tableData?.totalComplete ?? 0,
      color: "green",
    },
    {
      label: t("thead_incomplete"),
      value: tableData?.totalIncomeplete ?? 0,
      color: "orange",
    },
    {
      label: t("thead_give_late"),
      value: tableData?.totalLate ?? 0,
      color: "blue",
    },
    {
      label: t("thead_missing"),
      value: tableData?.totalMissing ?? 0,
      color: "red",
    },
    // {
    //   label: t("thead_female"),
    //   value: tableData?.totalFemale ?? 0,
    //   color: "gray",
    // },
    // {
    //   label: t("thead_total_student"),
    //   value: tableData?.totalStudent ?? 0,
    //   color: "#131870",
    // },
  ];

  return (
    <Stack direction="row" justifyContent="flex-end" sx={{ width: "100%" }}>
      <Grid container spacing={2}>
        {stats.map((item, index) => (
          <Grid item xs={3} sm={3} md={3} lg={3} xl={2}  key={index}>
            <Stack>
              <Typography
                className={t("class-name-text-field-title")}
                sx={{ color: "#131870", px: 1.75 }}
              >
                {item.label}
              </Typography>

              <Box
                sx={{
                  py: 1,
                  px: 1.75,
                  bgcolor: "white",
                  borderRadius: 1,
                }}
              >
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <Typography sx={{ fontWeight: "bold", color: item.color }}>
                    {item.value}
                  </Typography>
                  <Typography sx={{ color: "#131870" }}>pax</Typography>
                </Stack>
              </Box>
            </Stack>
          </Grid>
        ))}
      </Grid>
    </Stack>
  );
}
